export enum Role {
  TENANT_ADMIN = 'TENANT_ADMIN',
  TENANT_ADMIN_DRIVER = 'TENANT_ADMIN_DRIVER',
  DRIVER = 'DRIVER',
}

export enum InviteUserRole {
  TENANT_ADMIN_DRIVER = 'TENANT_ADMIN_DRIVER',
  DRIVER = 'DRIVER',
}

export const HUB_ADMINS = ['+905542989001', '+905455591600']

export const getRoles = (t: (arg: string) => string) => {
  return Object.values(InviteUserRole)?.map((role: string) => {
    return {
      text: t(`Schema.CarrierUserRoles.${role}`),
      value: role,
    }
  })
}
